import { matchValues } from '@shared/core/types/common';

const boxFeel: OLO.Components.BOX_FEEL[] = ['gold', 'primary'];

export const boxFeelType = matchValues(...boxFeel);
